// @flow
/**
 * Football Team Selection Logic
 * Defender->
 *        Min : 3
 *        Max : 5
 * Forward  ->
 *        Min : 1
 *        Max : 3
 * Midfielder  ->
 *        Min : 3
 *        Max : 5
 * GK ->
 *      Min : 1
 *      Max : 1
 *
 * and maximum 7 players from the one team
 */

import '../../cricket/create_team/index_web.css';
import { View, Text } from '../../../component';
import { useLink } from 'react-router-stack';
import CreateTeamHeaderFootball from '../../component/create_team_header_football';
import CreateTeamTabContentFootball from '../../component/create_team_tab_content_football/index_web';
import { isMatchInScheduled } from '../../../utilities/helper';
import Constants from '../../../constants';
import DefaultContainer from '../../../container/default_container';
import { CounterWrapper } from '../../../component/header_with_timer';
import Team_sorting_football from '../../component/team_sorting_football';
import GuideTour from '../../../component/guide_tour';
import { useSelector } from 'react-redux';

const CreateTeamWeb = ({
  teamNumber,
  teamAPlayersCount,
  teamA,
  teamB,
  teamBPlayersCount,
  matchItem,
  gameType,
  keeperList,
  defenderList,
  midfielderList,
  forwardList,
  sortName,
  sortType,
  onUpdateSortingList,
  onPressPlayer,
  activeTab,
  renderWhenEmpty,
  lineupsOut,
  keeperListDisable,
  defenderListDisable,
  midfielderListDisable,
  forwardListDisable,
  counts,
  totalCreditCount,
  onPressPlayerMinus,
  onChangeTab,
  routes,
  onPressTeamPreview,
  onPressContinue
}: any) => {
  const navigate = useLink();

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };
  const { teamName = '' } = useSelector((state: any) => state.user);

  const renderHeader = (matchItem: any, onCalledDeadline: any, gameType: any) => {
    const { status: matchStatus, verified, gameState = 0, matchDelayed = false } = matchItem;

    const isMatchScheduled = isMatchInScheduled({
      matchStatus,
      gameState,
      matchDelayed,
      gameType
    });
    const timerIconDimension = '20px';

    return (
      <>
        <div>
          <View className="fantasy_cricket_header_timer_wrapper" style={{ paddingLeft: '20px' }}>
            {isMatchScheduled && (
              <View className="header-with-timer-icon-wrapper">
                <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
              </View>
            )}
            {
              <CounterWrapper
                onCalledDeadline={onCalledDeadline}
                matchStatus={matchStatus}
                verified={verified}
                matchItem={matchItem}
                isMatchScheduled={isMatchScheduled}
                gameType={gameType}
              />
            }
          </View>
        </div>
      </>
    );
  };

  const isGuideTourCompleted =
    localStorage.getItem(Constants.GuideTour['create_team_football'].key) === 'true';
  return (
    <DefaultContainer>
      <div className="createTeam__wrapper__web" id="create_team_football">
        {!isGuideTourCompleted && (
          <GuideTour
            steps={Constants.GuideTour['create_team_football'].steps}
            keyValue={Constants.GuideTour['create_team_football'].key}
            elementId={'create_team_football'}
          />
        )}
        <View className={'create-team-container'} style={{ height: '100%' }}>
          <Text className={'createTeam__Header'}>{'Select Team'}</Text>
          <div
            className="create_team_header_title_wrapper"
            style={{ flexDirection: 'column', marginLeft: '5%', height: '10%' }}>
            <div className="create_team_header_title_container">
              <Text className={'create-team-header-team-name createTeam__teamNumber'}>
                {teamName ? ` ${teamName} (T${teamNumber})` : `Team No. ${teamNumber}`}
              </Text>
              <div style={{ display: 'flex' }}>
                <Text
                  className={
                    'create-team-header-team-name'
                  }>{`${teamA?.shortName} (${teamAPlayersCount})`}</Text>
                <Text className={'create-team-header-team-name'}>vs</Text>

                <Text
                  className={
                    'create-team-header-team-name'
                  }>{`${teamB?.shortName} (${teamBPlayersCount})`}</Text>
              </div>
              {renderHeader(matchItem, onCalledDeadline, gameType)}
            </div>
            <View className={'create-team-tab-content-sorting-header'}>
              <Team_sorting_football
                keeperList={keeperList}
                defenderList={defenderList}
                midfielderList={midfielderList}
                forwardList={forwardList}
                sortName={sortName}
                sortType={sortType}
                onUpdateSortingList={onUpdateSortingList}
              />
            </View>
          </div>

          {activeTab === 0 && (
            <View className="create-team-tab">
              <CreateTeamTabContentFootball
                data={keeperList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                keeperList={keeperList}
                defenderList={defenderList}
                midfielderList={midfielderList}
                forwardList={forwardList}
                lineupsOut={lineupsOut}
                keeperListDisable={keeperListDisable}
                defenderListDisable={defenderListDisable}
                midfielderListDisable={midfielderListDisable}
                forwardListDisable={forwardListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
          )}
          {activeTab === 1 && (
            <View className="create-team-tab">
              <CreateTeamTabContentFootball
                data={defenderList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                keeperList={keeperList}
                defenderList={defenderList}
                midfielderList={midfielderList}
                forwardList={forwardList}
                lineupsOut={lineupsOut}
                keeperListDisable={keeperListDisable}
                defenderListDisable={defenderListDisable}
                midfielderListDisable={midfielderListDisable}
                forwardListDisable={forwardListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
                substitutePlayers={undefined}
              />
            </View>
          )}
          {activeTab === 2 && (
            <View className="create-team-tab">
              <CreateTeamTabContentFootball
                data={midfielderList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                keeperList={keeperList}
                defenderList={defenderList}
                midfielderList={midfielderList}
                forwardList={forwardList}
                lineupsOut={lineupsOut}
                keeperListDisable={keeperListDisable}
                defenderListDisable={defenderListDisable}
                midfielderListDisable={midfielderListDisable}
                forwardListDisable={forwardListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
          )}
          {activeTab === 3 && (
            <View className="create-team-tab">
              <CreateTeamTabContentFootball
                data={forwardList}
                matchItem={matchItem}
                onPressPlayer={onPressPlayer}
                selectedTab={activeTab}
                renderWhenEmpty={renderWhenEmpty}
                keeperList={keeperList}
                defenderList={defenderList}
                midfielderList={midfielderList}
                forwardList={forwardList}
                lineupsOut={lineupsOut}
                keeperListDisable={keeperListDisable}
                defenderListDisable={defenderListDisable}
                midfielderListDisable={midfielderListDisable}
                forwardListDisable={forwardListDisable}
                teamAPlayersCount={teamAPlayersCount}
                teamBPlayersCount={teamBPlayersCount}
                totalCreditCount={totalCreditCount}
                onUpdateSortingList={onUpdateSortingList}
                sortName={sortName}
                sortType={sortType}
              />
            </View>
          )}
        </View>
        <div style={{ width: '40%', height: '100%' }}>
          <CreateTeamHeaderFootball
            counts={counts}
            teamACount={teamAPlayersCount}
            teamBCount={teamBPlayersCount}
            totalCreditCount={totalCreditCount}
            teamAName={teamA?.shortName}
            teamBName={teamB?.shortName}
            onPressPlayerMinus={onPressPlayerMinus}
            onChangeTab={onChangeTab}
            activeTab={activeTab}
            routes={routes}
            onPressTeamPreview={onPressTeamPreview}
            onPressContinue={onPressContinue}
          />
        </div>
      </div>
    </DefaultContainer>
  );
};
export default CreateTeamWeb;
